var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.333,
    height: 39.073,
    viewBox: "0 0 39.333 39.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "next-svgrepo-com",
    transform: "translate(39.095 -0.034) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_464",
    "data-name": "Ellipse 464",
    cx: 19.537,
    cy: 19.537,
    r: 19.537,
    transform: "translate(0.034 0.021)",
    fill: "#71ccf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85947",
    "data-name": "Path 85947",
    d: "M256,0V38.857A19.428,19.428,0,1,0,256,0Z",
    transform: "translate(-236.797 -0.238)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85948",
    "data-name": "Path 85948",
    d: "M106.057,134.9h11.379v8.034l10.112-10.115L117.436,122.7v8.034H106.057Z",
    transform: "translate(-98.234 -113.63)",
    fill: "#fff100"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4c4aed507420d3c603ff2107f211b570.svg";
export { ForwardRef as ReactComponent };